function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imageutils
 */
import { Plugin } from 'ckeditor5/src/core';
import { findOptimalInsertionRange, isWidget, toWidget } from 'ckeditor5/src/widget';
import { determineImageTypeForInsertionAtSelection } from './image/utils';
/**
 * A set of helpers related to images.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageUtils = /*#__PURE__*/function (_Plugin) {
  _inherits(ImageUtils, _Plugin);

  var _super = _createSuper(ImageUtils);

  function ImageUtils() {
    _classCallCheck(this, ImageUtils);

    return _super.apply(this, arguments);
  }

  _createClass(ImageUtils, [{
    key: "isImage",
    value:
    /**
     * Checks if the provided model element is an `image` or `imageInline`.
     *
     * @param {module:engine/model/element~Element} modelElement
     * @returns {Boolean}
     */
    function isImage(modelElement) {
      return this.isInlineImage(modelElement) || this.isBlockImage(modelElement);
    }
    /**
     * Checks if the provided view element represents an inline image.
     *
     * Also, see {@link module:image/imageutils~ImageUtils#isImageWidget}.
     *
     * @param {module:engine/view/element~Element} element
     * @returns {Boolean}
     */

  }, {
    key: "isInlineImageView",
    value: function isInlineImageView(element) {
      return !!element && element.is('element', 'img');
    }
    /**
     * Checks if the provided view element represents a block image.
     *
     * Also, see {@link module:image/imageutils~ImageUtils#isImageWidget}.
     *
     * @param {module:engine/view/element~Element} element
     * @returns {Boolean}
     */

  }, {
    key: "isBlockImageView",
    value: function isBlockImageView(element) {
      return !!element && element.is('element', 'figure') && element.hasClass('image');
    }
    /**
     * Handles inserting single file. This method unifies image insertion using {@link module:widget/utils~findOptimalInsertionRange}
     * method.
     *
     *		const imageUtils = editor.plugins.get( 'ImageUtils' );
     *
     *		imageUtils.insertImage( { src: 'path/to/image.jpg' } );
     *
     * @param {Object} [attributes={}] Attributes of the inserted image.
     * This method filters out the attributes which are disallowed by the {@link module:engine/model/schema~Schema}.
     * @param {module:engine/model/selection~Selectable} [selectable] Place to insert the image. If not specified,
     * the {@link module:widget/utils~findOptimalInsertionRange} logic will be applied for the block images
     * and `model.document.selection` for the inline images.
     *
     * **Note**: If `selectable` is passed, this helper will not be able to set selection attributes (such as `linkHref`)
     * and apply them to the new image. In this case, make sure all selection attributes are passed in `attributes`.
     *
     * @param {'imageBlock'|'imageInline'} [imageType] Image type of inserted image. If not specified,
     * it will be determined automatically depending of editor config or place of the insertion.
     * @return {module:engine/view/element~Element|null} The inserted model image element.
     */

  }, {
    key: "insertImage",
    value: function insertImage() {
      var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var selectable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var imageType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var editor = this.editor;
      var model = editor.model;
      var selection = model.document.selection;
      imageType = determineImageTypeForInsertion(editor, selectable || selection, imageType); // Mix declarative attributes with selection attributes because the new image should "inherit"
      // the latter for best UX. For instance, inline images inserted into existing links
      // should not split them. To do that, they need to have "linkHref" inherited from the selection.

      attributes = _objectSpread(_objectSpread({}, Object.fromEntries(selection.getAttributes())), attributes);

      for (var attributeName in attributes) {
        if (!model.schema.checkAttribute(imageType, attributeName)) {
          delete attributes[attributeName];
        }
      }

      return model.change(function (writer) {
        var imageElement = writer.createElement(imageType, attributes); // If we want to insert a block image (for whatever reason) then we don't want to split text blocks.
        // This applies only when we don't have the selectable specified (i.e., we insert multiple block images at once).

        if (!selectable && imageType != 'imageInline') {
          selectable = findOptimalInsertionRange(selection, model);
        }

        model.insertContent(imageElement, selectable); // Inserting an image might've failed due to schema regulations.

        if (imageElement.parent) {
          writer.setSelection(imageElement, 'on');
          return imageElement;
        }

        return null;
      });
    }
    /**
     * Returns an image widget editing view element if one is selected or is among the selection's ancestors.
     *
     * @protected
     * @param {module:engine/view/selection~Selection|module:engine/view/documentselection~DocumentSelection} selection
     * @returns {module:engine/view/element~Element|null}
     */

  }, {
    key: "getClosestSelectedImageWidget",
    value: function getClosestSelectedImageWidget(selection) {
      var viewElement = selection.getSelectedElement();

      if (viewElement && this.isImageWidget(viewElement)) {
        return viewElement;
      }

      var parent = selection.getFirstPosition().parent;

      while (parent) {
        if (parent.is('element') && this.isImageWidget(parent)) {
          return parent;
        }

        parent = parent.parent;
      }

      return null;
    }
    /**
     * Returns a image model element if one is selected or is among the selection's ancestors.
     *
     * @param {module:engine/model/selection~Selection|module:engine/model/documentselection~DocumentSelection} selection
     * @returns {module:engine/model/element~Element|null}
     */

  }, {
    key: "getClosestSelectedImageElement",
    value: function getClosestSelectedImageElement(selection) {
      var selectedElement = selection.getSelectedElement();
      return this.isImage(selectedElement) ? selectedElement : selection.getFirstPosition().findAncestor('imageBlock');
    }
    /**
     * Checks if image can be inserted at current model selection.
     *
     * @protected
     * @returns {Boolean}
     */

  }, {
    key: "isImageAllowed",
    value: function isImageAllowed() {
      var model = this.editor.model;
      var selection = model.document.selection;
      return isImageAllowedInParent(this.editor, selection) && isNotInsideImage(selection);
    }
    /**
     * Converts a given {@link module:engine/view/element~Element} to an image widget:
     * * Adds a {@link module:engine/view/element~Element#_setCustomProperty custom property} allowing to recognize the image widget
     * element.
     * * Calls the {@link module:widget/utils~toWidget} function with the proper element's label creator.
     *
     * @protected
     * @param {module:engine/view/element~Element} viewElement
     * @param {module:engine/view/downcastwriter~DowncastWriter} writer An instance of the view writer.
     * @param {String} label The element's label. It will be concatenated with the image `alt` attribute if one is present.
     * @returns {module:engine/view/element~Element}
     */

  }, {
    key: "toImageWidget",
    value: function toImageWidget(viewElement, writer, label) {
      var _this = this;

      writer.setCustomProperty('image', true, viewElement);

      var labelCreator = function labelCreator() {
        var imgElement = _this.getViewImageFromWidget(viewElement);

        var altText = imgElement.getAttribute('alt');
        return altText ? "".concat(altText, " ").concat(label) : label;
      };

      return toWidget(viewElement, writer, {
        label: labelCreator
      });
    }
    /**
     * Checks if a given view element is an image widget.
     *
     * @protected
     * @param {module:engine/view/element~Element} viewElement
     * @returns {Boolean}
     */

  }, {
    key: "isImageWidget",
    value: function isImageWidget(viewElement) {
      return !!viewElement.getCustomProperty('image') && isWidget(viewElement);
    }
    /**
     * Checks if the provided model element is an `image`.
     *
     * @param {module:engine/model/element~Element} modelElement
     * @returns {Boolean}
     */

  }, {
    key: "isBlockImage",
    value: function isBlockImage(modelElement) {
      return !!modelElement && modelElement.is('element', 'imageBlock');
    }
    /**
     * Checks if the provided model element is an `imageInline`.
     *
     * @param {module:engine/model/element~Element} modelElement
     * @returns {Boolean}
     */

  }, {
    key: "isInlineImage",
    value: function isInlineImage(modelElement) {
      return !!modelElement && modelElement.is('element', 'imageInline');
    }
    /**
     * Get view `<img>` element from the view widget (`<figure>`).
     *
     * Assuming that image is always a first child of a widget (ie. `figureView.getChild( 0 )`) is unsafe as other features might
     * inject their own elements to the widget.
     *
     * The `<img>` can be wrapped to other elements, e.g. `<a>`. Nested check required.
     *
     * @protected
     * @param {module:engine/view/element~Element} figureView
     * @returns {module:engine/view/element~Element}
     */

  }, {
    key: "getViewImageFromWidget",
    value: function getViewImageFromWidget(figureView) {
      if (this.isInlineImageView(figureView)) {
        return figureView;
      }

      var figureChildren = [];

      var _iterator = _createForOfIteratorHelper(figureView.getChildren()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var figureChild = _step.value;
          figureChildren.push(figureChild);

          if (figureChild.is('element')) {
            figureChildren.push.apply(figureChildren, _toConsumableArray(figureChild.getChildren()));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return figureChildren.find(this.isInlineImageView);
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'ImageUtils';
    }
  }]);

  return ImageUtils;
}(Plugin); // Checks if image is allowed by schema in optimal insertion parent.
//
// @private
// @param {module:core/editor/editor~Editor} editor
// @param {module:engine/model/selection~Selection} selection
// @returns {Boolean}


export { ImageUtils as default };

function isImageAllowedInParent(editor, selection) {
  var imageType = determineImageTypeForInsertion(editor, selection);

  if (imageType == 'imageBlock') {
    var parent = getInsertImageParent(selection, editor.model);

    if (editor.model.schema.checkChild(parent, 'imageBlock')) {
      return true;
    }
  } else if (editor.model.schema.checkChild(selection.focus, 'imageInline')) {
    return true;
  }

  return false;
} // Checks if selection is not placed inside an image (e.g. its caption).
//
// @private
// @param {module:engine/model/selection~Selectable} selection
// @returns {Boolean}


function isNotInsideImage(selection) {
  return _toConsumableArray(selection.focus.getAncestors()).every(function (ancestor) {
    return !ancestor.is('element', 'imageBlock');
  });
} // Returns a node that will be used to insert image with `model.insertContent`.
//
// @private
// @param {module:engine/model/selection~Selection} selection
// @param {module:engine/model/model~Model} model
// @returns {module:engine/model/element~Element}


function getInsertImageParent(selection, model) {
  var insertionRange = findOptimalInsertionRange(selection, model);
  var parent = insertionRange.start.parent;

  if (parent.isEmpty && !parent.is('element', '$root')) {
    return parent.parent;
  }

  return parent;
} // Determine image element type name depending on editor config or place of insertion.
//
// @private
// @param {module:core/editor/editor~Editor} editor
// @param {module:engine/model/selection~Selectable} selectable
// @param {'imageBlock'|'imageInline'} [imageType] Image element type name. Used to force return of provided element name,
// but only if there is proper plugin enabled.
// @returns {'imageBlock'|'imageInline'} imageType


function determineImageTypeForInsertion(editor, selectable, imageType) {
  var schema = editor.model.schema;
  var configImageInsertType = editor.config.get('image.insert.type');

  if (!editor.plugins.has('ImageBlockEditing')) {
    return 'imageInline';
  }

  if (!editor.plugins.has('ImageInlineEditing')) {
    return 'imageBlock';
  }

  if (imageType) {
    return imageType;
  }

  if (configImageInsertType === 'inline') {
    return 'imageInline';
  }

  if (configImageInsertType === 'block') {
    return 'imageBlock';
  } // Try to replace the selected widget (e.g. another image).


  if (selectable.is('selection')) {
    return determineImageTypeForInsertionAtSelection(schema, selectable);
  }

  return schema.checkChild(selectable, 'imageInline') ? 'imageInline' : 'imageBlock';
}